import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import Head from './../components/Head';
import Footer from './../components/Footer';
import Case from './components/Case';
import FilterBox from './components/FilterBox';
import Course from './components/Course';
import latestActivity from './components/latestActivity.vue';
import { defineComponent, inject, ref } from 'vue';
import { setStorage, getStorage } from '@/plugins/store';
import news from './components/news.vue';
import notice from './components/notice.vue';
export default defineComponent({
  components: {
    Head,
    Case,
    FilterBox,
    Footer,
    Course,
    latestActivity,
    news,
    notice
  },
  setup() {
    const $utils = inject('$utils');
    const $http = inject('$http');
    const currentTab = ref('案例展示');
    const selectType = ref([{
      id: 0,
      name: '全库'
    }, {
      id: 1,
      name: '首席专家'
    }, {
      id: 2,
      name: '案例名称'
    }]);
    const selectTypeId = ref(0);

    // 获取当前页面tab 渲染对应卡片
    const urlTab = +$utils.getUrlParams('tab');
    const activeTab = ref(urlTab ? urlTab : 1);

    // 获取高级设置
    const currentMenuId = ref('');
    const highSetting = ref([]);
    const highSettingForm = ref(null);
    const sortKey = ref('');
    const dataShow = ref('');
    const getHighSet = async () => {
      const res = await $http.getHighSetting({
        business_type: activeTab.value,
        menu_id: currentMenuId.value
      });
      highSetting.value = res;
      let obj = {};
      res.forEach(item => {
        obj[item.key_str] = item.value_str;
      });
      const {
        get_data,
        default_sort
      } = obj;
      dataShow.value = get_data;
      sortKey.value = default_sort;
      getCaseList();
    };

    // 获取导航
    const tabList = ref([]);
    const getNavList = async () => {
      const list = await $http.getNavList();
      console.log('导航', list);
      const newList = list.map(item => ({
        ...item,
        tab: item.function_id == '52006' ? 1 : 2
      }));
      // 路由集合
      const urlList = {
        52006: '/index.html?',
        52007: '/index.html?'
      };
      // 点击导航跳转到对应taget_url,并传参
      // 重新组装数据
      const data = newList.map(item => ({
        ...item,
        target_url: item.target_page == 1 ? item.target_url : `${urlList[item.function_id]}tab=${item.tab}&menuId=${item.menu_id}&name=${item.nav_name}`
      }));

      // 获取过滤后的最终的nav列表 auth_type 1 无需登录 2 详情需登录 3 菜单需登录
      const userInfo = getStorage('userInfo');
      tabList.value = !userInfo ? data.filter(item => item.auth_type !== 3) : data;

      // 当前页面 导航高亮
      let currentPageIndex = 0;
      if ($utils.getUrlParams('menuId')) currentPageIndex = (tabList.value || []).findIndex(item => item.menu_id == $utils.getUrlParams('menuId'));
      if (tabList.value[currentPageIndex]) {
        currentTab.value = tabList.value[currentPageIndex].nav_name;
        currentMenuId.value = tabList.value[currentPageIndex].menu_id;
        activeTab.value = tabList.value[currentPageIndex].tab;
        getHighSet(); // 拿到menuId后才能获取高级设置
      }
    };
    // getNavList()

    const pageInfo = reactive({
      pageSize: 16,
      pageNum: 1,
      total: 0
    });

    // 排序
    const orderType = ref(1);
    function sortHandle(sort) {
      orderType.value = sort.sortType;
      sortKey.value = sort.sortKey;
      pageInfo.pageNum = 1;
      getCaseList();
    }
    const ideologyid = ref();
    const search = ref();
    const orgid = ref();
    const major_id = ref();
    const major_flag = ref();
    const type_id = ref();
    const handleClick = item => {
      console.log(item);
      activeTab.value = item.id;
      window.location.href = `/index.html?tab=${activeTab.value}`;
    };
    const caseList = ref([]);
    const courseList = ref([]);
    async function getCaseList() {
      let params = {
        '_pageable.page': pageInfo.pageNum - 1,
        '_pageable.size': pageInfo.pageSize,
        dataStatus: dataShow.value,
        // 1审核通过 2全部案例
        sortV: orderType.value || undefined,
        // saveStatus: saveStatus.value || undefined, //  1系统 2 自主
        orgIds: +orgid.value > 0 ? orgid.value : undefined,
        findName: search.value || undefined,
        sortK: sortKey.value || undefined // 1 查看量 2 引用量 3 上架时间
      };
      if (activeTab.value == 1) {
        let paramsCase = {
          major_ids: +major_id.value > 0 ? major_id.value : undefined,
          ideology_ids: +ideologyid.value > 0 ? ideologyid.value : undefined
        };
        const res = await $http.getCaseList({
          ...params,
          ...paramsCase
        });
        caseList.value = res.content;
        console.log('案例列表', res);
        pageInfo.total = +res.totalElements;
      } else {
        let paramsCourse = {
          courseTypes: +type_id.value > 0 ? type_id.value : undefined
        };
        const res2 = await $http.getCourseList({
          ...params,
          ...paramsCourse
        });
        courseList.value = res2.content;
        console.log('课程', res2);
        pageInfo.total = +res2.totalElements;
      }
    }
    function pageChange(page) {
      pageInfo.pageNum = page;
      getCaseList();
    }
    function pageChangeCourse(page) {
      console.log(page);
      pageInfo.pageNum = page;
      getCaseList();
    }
    function ideologChange(id) {
      ideologyid.value = id;
      getCaseList();
    }
    function collegeChange(id) {
      orgid.value = id;
      getCaseList();
    }
    function majorChange(params) {
      major_id.value = params.id;
      major_flag.value = params.major_flag;
      getCaseList();
    }
    function typeChange(id) {
      type_id.value = id;
      getCaseList();
    }
    function searchHandle(val) {
      console.log(val);
      search.value = val;
      getCaseList();
    }
    const newsModule = ref(null);
    const noticeModule = ref(null);
    const getCaseMenuList = async () => {
      const res = await $http.getCaseMenuList();
      newsModule.value = res.filter(item => item.module_name === '新闻动态')[0];
      noticeModule.value = res.filter(item => item.module_name === '通知公告')[0];
    };
    getCaseMenuList();
    const searchValue = ref('');
    const caseTypeList = ref([]);
    const currentCaseType = ref('');
    async function getCaseTypeList() {
      const res = await $http.getCaseTypeList();
      caseTypeList.value = res;
    }
    getCaseTypeList();
    function handleCaseTypeChange(item) {
      if (currentCaseType.value == item.id) {
        currentCaseType.value = '';
      } else {
        currentCaseType.value = item.id;
      }
    }
    function searchCase() {
      window.location.href = `/caseList.html?caseTypeId=${currentCaseType.value}&keyWord=${searchValue.value.trim()}&keyWordType=${selectTypeId.value}`;
    }
    return {
      locale: zhCn,
      // hasLogin,
      tabList,
      getNavList,
      currentTab,
      highSetting,
      sortKey,
      courseList,
      pageInfo,
      caseList,
      getCaseList,
      sortHandle,
      pageChange,
      pageChangeCourse,
      ideologChange,
      collegeChange,
      majorChange,
      typeChange,
      searchHandle,
      activeTab,
      handleClick,
      newsModule,
      noticeModule,
      searchValue,
      caseTypeList,
      currentCaseType,
      handleCaseTypeChange,
      searchCase,
      selectType,
      selectTypeId
    };
  }
});